export const formatWithLeadingZero = (number: number) => {
  return String(number).padStart(2, '0');
};
